var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2142 16.9999C62.8367 16.9999 74.6905 28.8644 74.6905 43.4999C74.6905 58.1353 62.8367 69.9999 48.2142 69.9999C33.5919 69.9999 21.7381 58.1353 21.7381 43.4999C21.7381 28.8644 33.5919 16.9999 48.2142 16.9999Z",
    fill: "#FF4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2142 16.9999C62.8367 16.9999 74.6905 28.8644 74.6905 43.4999C74.6905 58.1353 62.8367 69.9999 48.2142 69.9999C33.5919 69.9999 21.7381 58.1353 21.7381 43.4999C21.7381 28.8644 33.5919 16.9999 48.2142 16.9999Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7202 0.999936H52.7112C69.2649 0.999936 82.6843 14.4311 82.6843 30.9999V40.9999C82.6843 57.5682 69.2649 70.9998 52.7112 70.9998H42.7202C26.1666 70.9998 12.7472 57.5682 12.7472 40.9999V30.9999C12.7472 14.4311 26.1666 0.999936 42.7202 0.999936Z",
    fill: "#FF4361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7202 0.999936H52.7112C69.2649 0.999936 82.6843 14.4311 82.6843 30.9999V40.9999C82.6843 57.5682 69.2649 70.9998 52.7112 70.9998H42.7202C26.1666 70.9998 12.7472 57.5682 12.7472 40.9999V30.9999C12.7472 14.4311 26.1666 0.999936 42.7202 0.999936Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.144 41.6371C51.3558 41.422 51.4618 41.1682 51.4618 40.8747V38.1661H62.7015V46.2925C62.7015 47.0365 62.4396 47.6747 61.9154 48.2048C61.3914 48.7354 60.7612 49.0005 60.0255 49.0005H35.4047C34.6687 49.0005 34.0386 48.7354 33.5145 48.2048C32.9903 47.6747 32.7284 47.0365 32.7284 46.2925V38.1661H43.9683V40.8747C43.9683 41.1682 44.0743 41.422 44.2861 41.6371C44.498 41.851 44.7489 41.9586 45.0389 41.9586H50.3912C50.6811 41.9586 50.9321 41.851 51.144 41.6371ZM49.8561 38.1661H45.5739V40.3328H49.8561V38.1661ZM61.9154 28.1274C61.3914 27.5962 60.7612 27.3312 60.0255 27.3312H54.1376V24.6226C54.1376 24.171 53.9817 23.7876 53.6693 23.471C53.3574 23.1559 52.978 22.9973 52.5322 22.9973H42.898C42.4519 22.9973 42.0729 23.1559 41.7606 23.471C41.4484 23.7871 41.2923 24.171 41.2923 24.6226V27.3312H35.4047C34.6687 27.3312 34.0386 27.5962 33.5145 28.1274C32.9903 28.657 32.7284 29.2946 32.7284 30.0398V36.5408H62.7015V30.0398C62.7015 29.2946 62.4396 28.657 61.9154 28.1274ZM51.9969 27.3312H43.4332V25.164H51.9969V27.3312Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.738068,
    y: 9,
    width: 94.9524,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.266667 0 0 0 0 0.341176 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 52.3458,
    y1: 102.635,
    x2: 107.353,
    y2: 39.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC4E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 53.1242,
    y1: 113.413,
    x2: 125.133,
    y2: 30.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature-1.c0570feb433caca909ec7c2751a1b0f7.svg";
export { ForwardRef as ReactComponent };